export default __webpack_public_path__ + "static/media/Instagram icon.8468cad1.svg";